export interface FileSystemEntry {
  name: string;
  isDirectory: boolean;
  isFile: boolean;
}

export interface FileSystemEntryMetadata {
  modificationTime?: Date;
  size?: number;
}

export interface FileSystemDirectoryReader {
  readEntries(
    successCallback: (result: FileSystemEntry[]) => void,
    errorCallback?: (error: DOMException) => void,
  ): void;
}

export interface FileSystemFlags {
  create?: boolean;
  exclusive?: boolean;
}

export interface FileSystemDirectoryEntry extends FileSystemEntry {
  isDirectory: true;
  isFile: false;
  createReader(): FileSystemDirectoryReader;
  getFile(
    path?: string,
    options?: FileSystemFlags,
    successCallback?: (result: FileSystemFileEntry) => void,
    errorCallback?: (error: DOMException) => void,
  ): void;
  getDirectory(
    path?: string,
    options?: FileSystemFlags,
    successCallback?: (result: FileSystemDirectoryEntry) => void,
    errorCallback?: (error: DOMException) => void,
  ): void;
}

export interface FileSystemFileEntry extends FileSystemEntry {
  isDirectory: false;
  isFile: true;
  file<T>(callback: (file: File) => T): T;
}

export class EmmaFileDropEntry {
  constructor(
    public relativePath: string,
    public fileEntry: FileSystemEntry
  ) {
  }
}
